(function () {
  const root = document.getElementById('rn-brand-stories-root');
  if (!root) return;

  const labels = {
    tileLink: root.getAttribute('data-label-tile-link') || '',
    backBtn: root.getAttribute('data-label-back-btn') || '',
    estPrefix: root.getAttribute('data-label-est-prefix') || '',
    certifications: root.getAttribute('data-label-certifications') || '',
    renovaVerification: root.getAttribute('data-label-renova-verification') || '',
    materialsEyebrow: root.getAttribute('data-label-materials-eyebrow') || '',
    materialsHeading: root.getAttribute('data-label-materials-heading') || '',
    ethosEyebrow: root.getAttribute('data-label-ethos-eyebrow') || '',
    ethosHeading: root.getAttribute('data-label-ethos-heading') || '',
    renovaCarries: root.getAttribute('data-label-renova-carries') || '',
    ctaArrow: root.getAttribute('data-label-cta-arrow') || ''
  };

  let brands = [];
  const dataEl = document.getElementById('rn-brand-stories-data');
  if (dataEl) {
    try {
      brands = JSON.parse(dataEl.textContent || '[]');
    } catch (e) {
      brands = [];
    }
  }

  brands = brands.map(function (b) {
    const out = Object.assign({}, b);
    if (out.landingCta && !out.landingCta.label) {
      out.landingCta = null;
    }
    if (!out.sidebarCallout) {
      delete out.sidebarCallout;
    }
    if (!out.logo) {
      delete out.logo;
    }
    if (!out.founded) {
      delete out.founded;
    }
    if (!out.ethos || !out.ethos.length) {
      delete out.ethos;
    }
    return out;
  });

  function renderAll() {
    const hiddenBrandIds = new Set(['openform', 'akaya', 'avidi', 'ahmev', 'maddermuch']);
    const visible = brands.filter((b) => !hiddenBrandIds.has(b.id));
    visible.sort((a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }));
    const grid = root.querySelector('#brand-grid');
    const pages = root.querySelector('#brand-pages');
    if (!grid || !pages) return;

    grid.innerHTML = '';
    pages.innerHTML = '';

    visible.forEach((b, i) => {
      const tileTop = b.logo
        ? `<div class="tile-logo-wrap"><img class="tile-logo" src="${b.logo}" alt="" loading="lazy" decoding="async" /></div>`
        : `<div class="tile-swatch ${b.fx}"></div>`;
      grid.innerHTML += `<div class="brand-tile" onclick="showBrand('${b.id}')">
` +
        `  ${tileTop}
` +
        `  <div class="tile-num">0${i+1<10?'0'+(i+1):i+1}</div>
` +
        `  <div class="tile-tag">${b.tag}</div>
` +
        `  <div class="tile-name">${b.name}</div>
` +
        `  <div class="tile-loc">${b.loc}</div>
` +
        `  <div class="tile-desc">${b.heroLine}</div>
` +
        `  <div class="tile-link">${labels.tileLink}</div>
` +
        `</div>`;

      const certs = b.certs.map(c => {
        const [cls, ...rest] = c.split(' ');
        return `<span class="cert ${cls}">${rest.join(' ')}</span>`;
      }).join('');

      const asideHTML = b.aside.map(a => {
        if (a.stat) return `<div class="aside-box"><div class="aside-stat">${a.stat}</div><p>${a.label}</p></div>`;
        return `<div class="aside-box"><h4>${a.title}</h4><ul>${a.items.map(i => `<li>${i}</li>`).join('')}</ul></div>`;
      }).join('');

      const mats = b.materials.map(m => `<div class="mat-item"><div class="mat-swatch ${m.fx}"></div><div class="mat-name">${m.name}</div><div class="mat-desc">${m.desc}</div></div>`).join('');
      const storyHTML = b.story.map(s => s.type === 'lead' ? `<p class="lead">${s.text}</p>` : `<p>${s.text}</p>`).join('');
      const calloutHTML = b.sidebarCallout ? `<div class="aside-callout"><p>${b.sidebarCallout}</p></div>` : '';
      const ethosHTML = (b.ethos && b.ethos.length) ? `<section class="brand-ethos"><div class="brand-ethos-inner"><p class="eyebrow">${labels.ethosEyebrow}</p><h2 class="brand-ethos-heading">${labels.ethosHeading}</h2><div class="ethos-grid">${b.ethos.map(e => `<div class="ethos-item"><h3 class="ethos-item-title"><span class="ethos-item-eyebrow">${e.span}</span>${e.title}</h3><p class="ethos-item-text">${e.text}</p></div>`).join('')}</div></div></section>` : '';
      const landingCtaHTML = b.landingCta && b.landingCta.url ? `<div class="brand-landing-cta"><a href="${b.landingCta.url}" class="brand-cta-btn">${b.landingCta.label}${labels.ctaArrow}</a></div>` : '';
      const renovaCarriesHeading = labels.renovaCarries.replace('{name}', b.name);

      pages.innerHTML += `<div class="page" id="page-${b.id}">
` +
        `  <div class="brand-hero ${b.bg}">
` +
        `    <div class="brand-hero-overlay"></div>
` +
        `    <div class="brand-hero-content">
` +
        `      <button class="back-btn" onclick="showPage('index')">${labels.backBtn}</button>
` +
        `      <div class="brand-hero-tag">${b.tag} · ${b.loc}${b.founded ? ' · ' + labels.estPrefix + b.founded : ''}</div>
` +
        `      <h1 class="brand-hero-name">${b.name}</h1>
` +
        `      <p class="brand-hero-line">${b.tagline}</p>
` +
        `    </div>
` +
        `  </div>
` +
        `  <div class="brand-meta-strip"><div class="brand-meta-inner">${b.meta.map(m => `<div class="meta-item"><div class="meta-label">${m.l}</div><div class="meta-val">${m.v}</div></div>`).join('')}<div class="meta-item"><div class="meta-label">${labels.certifications}</div><div>${certs}</div></div></div></div>
` +
        `  <div class="brand-body"><div class="story-grid"><div class="story-text">${storyHTML}</div><div class="story-aside">${asideHTML}${calloutHTML}<div class="dark-box"><h4>${labels.renovaVerification}</h4><p>${b.renovaNote}</p></div></div></div></div>
` +
        `  <div class="pull-quote" style="max-width:1400px;margin:0 auto"><q>${b.pullQuote.q}</q><cite>${b.pullQuote.cite}</cite></div>
` +
        `  <div class="materials-strip"><div class="materials-strip-inner"><div class="eyebrow">${labels.materialsEyebrow}</div><h2 class="materials-strip-heading">${labels.materialsHeading}</h2><div class="mats-grid">${mats}</div></div></div>
` +
        ethosHTML +
        landingCtaHTML +
        `  <div class="renova-note"><div class="renova-note-inner"><h3>${renovaCarriesHeading}</h3><p>${b.renovaNote}</p></div></div>
` +
        `</div>`;
    });
  }

  window.showPage = function (name) {
    root.querySelectorAll('.page').forEach(p => p.classList.remove('active'));
    const target = root.querySelector('#page-' + name);
    if (target) target.classList.add('active');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  window.showBrand = function (id) { showPage(id); };

  renderAll();
})();
